(function($) {
	
	$('.related-posts-articles > div').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		arrows: true,
		dots: true,
		prevArrow: '<a href="#" class="slick-arrow prev"><i class="fas fa-chevron-left"></i></a>',
		nextArrow: '<a href="#" class="slick-arrow next"><i class="fas fa-chevron-right"></i></a>',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

})(jQuery);